import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Divider, RaisedButton, Card, CardText, Table, TableHeader, TableBody, TableRow, TableHeaderColumn,
  TableRowColumn
} from "material-ui";
import { OpenFiltroBusquedaDetalle } from "../FiltroBusqueda/actions";
import styles from "./../../styles/styles";

class ConsultaRecargos extends React.Component {
  componentWillMount() {
  }

  OpenFiltroBusquedaDetalle = () => {
    this.props.dispatch(OpenFiltroBusquedaDetalle(true));
    // urlHelper.RedirectTo("RecargosDetalleConvenios");
  }

  GetValorRecargo = (idTipoRecargo, tipoAtencion) => {
    const recargo = this.props.recargosConvenidos.filter((r) => r.IdTipoRecargo === idTipoRecargo && r.TipoAtencion === tipoAtencion);
    if (recargo && recargo.length === 1) {
      return recargo[0].Valor == "1,0" ? 'No tiene recargo' : recargo[0].Valor;
    }
    return 'No tiene recargo';
  }

  render() {
    const { tipoPrestacionSelected } = this.props;

    let valorHorarioHabilAmb = "-";
    let valorHorarioInhabilAmb = "-";
    let valorUrgenciaHabilAmb = "-";
    let valorUrgenciaInhabilAmb = "-";
    let valorTecnicasAmb = {};

    let valorHorarioHabilHost = "-";
    let valorHorarioInhabilHost = "-";
    let valorUrgenciaHabilHost = "-";
    let valorUrgenciaInhabilHost = "-";
    let valorTecnicasHost = {};

    if (this.props.recargosConvenidos && this.props.recargosConvenidos.length > 0) {
      let tAtencion = "A";
      valorHorarioHabilAmb = this.GetValorRecargo(31, tAtencion);
      valorHorarioInhabilAmb = this.GetValorRecargo(32, tAtencion);
      valorUrgenciaHabilAmb = this.GetValorRecargo(33, tAtencion);
      valorUrgenciaInhabilAmb = this.GetValorRecargo(34, tAtencion);

      /*
        * Valores para Técnicas
        * @params
        * valorTecnicasAmb: object,
        * tAtencion: string = 'A',
        * IdTipoRecargo: number = 31 ... 34, 54 ... 64
        * @desc
        * Permite presentar valor del recargo al prestador para técnicas.
      */

      valorTecnicasAmb = {
        'Tradicional': this.GetValorRecargo(55, tAtencion),
        'Radiocirugia': this.GetValorRecargo(56, tAtencion),
        'Endoscopia': this.GetValorRecargo(57, tAtencion),
        'Esterotaxica': this.GetValorRecargo(58, tAtencion),
        'Termoterapia': this.GetValorRecargo(59, tAtencion),
        'Microscopica': this.GetValorRecargo(60, tAtencion),
        'Lasik': this.GetValorRecargo(61, tAtencion),
        'Rayo Laser': this.GetValorRecargo(62, tAtencion),
        'Video Laparoscopica': this.GetValorRecargo(63, tAtencion),
        'Endovascular': this.GetValorRecargo(64, tAtencion),
      };

      tAtencion = "H";
      valorHorarioHabilHost = this.GetValorRecargo(31, tAtencion);
      valorHorarioInhabilHost = this.GetValorRecargo(32, tAtencion);
      valorUrgenciaHabilHost = this.GetValorRecargo(33, tAtencion);
      valorUrgenciaInhabilHost = this.GetValorRecargo(34, tAtencion);

      /*
        * Valores para Técnicas
        * @params
        * valorTecnicasHost: object,
        * tAtencion: string = H',
        * IdTipoRecargo: number = 31 ... 34, 54 ... 64
        * @desc
        * Permite presentar valor del recargo al prestador para técnicas.
      */

      valorTecnicasHost = {
        'Tradicional': this.GetValorRecargo(55, tAtencion),
        'Radiocirugia': this.GetValorRecargo(56, tAtencion),
        'Endoscopia': this.GetValorRecargo(57, tAtencion),
        'Esterotaxica': this.GetValorRecargo(58, tAtencion),
        'Termoterapia': this.GetValorRecargo(59, tAtencion),
        'Microscopica': this.GetValorRecargo(60, tAtencion),
        'Lasik': this.GetValorRecargo(61, tAtencion),
        'Rayo Laser': this.GetValorRecargo(62, tAtencion),
        'Video Laparoscopica': this.GetValorRecargo(63, tAtencion),
        'Endovascular': this.GetValorRecargo(64, tAtencion),
      };
    }

    return (
      <div style={{ padding: "5px" }}>
        <Card zDepth={0}>
          <CardText style={{ paddingTop: 0 }}>
            <div className="row" style={{ paddingTop: 0 }}>
              <div className="col-6">
                <Table
                  key="tablaConsultaRecargos"
                  fixedHeader
                  fixedFooter
                  selectable={false}
                >
                  <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                    <TableRow selectable={false}>
                      <TableHeaderColumn style={styles.tituloTablaRecargos1}>Tipo de Recargo</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaRecargos2}>Ambulatorio</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaRecargos3}>Hospitalario</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={false}
                    showRowHover
                    stripedRows={false}
                  >
                    <TableRow key="horarioHabil">
                      <TableRowColumn style={styles.tituloTablaRecargos1}>Horario Hábil</TableRowColumn>
                      <TableRowColumn style={styles.contTablaRecargos2}>{valorHorarioHabilAmb}</TableRowColumn>
                      <TableRowColumn style={styles.contTablaRecargos3}>{valorHorarioHabilHost}</TableRowColumn>
                    </TableRow>
                    <TableRow key="horarioInhabil">
                      <TableRowColumn style={styles.tituloTablaRecargos1}>Horario Inhábil</TableRowColumn>
                      <TableRowColumn style={styles.contTablaRecargos2}>{valorHorarioInhabilAmb}</TableRowColumn>
                      <TableRowColumn style={styles.contTablaRecargos3}>{valorHorarioInhabilHost}</TableRowColumn>
                    </TableRow>
                    <TableRow key="urgenciaHabil">
                      <TableRowColumn style={styles.tituloTablaRecargos1}>Urgencia Hábil</TableRowColumn>
                      <TableRowColumn style={styles.contTablaRecargos2}>{valorUrgenciaHabilAmb}</TableRowColumn>
                      <TableRowColumn style={styles.contTablaRecargos3}>{valorUrgenciaHabilHost}</TableRowColumn>
                    </TableRow>
                    <TableRow key="urgenciaInhabil">
                      <TableRowColumn style={styles.tituloTablaRecargos1}>Urgencia Inhábil</TableRowColumn>
                      <TableRowColumn style={styles.contTablaRecargos2}>{valorUrgenciaInhabilAmb}</TableRowColumn>
                      <TableRowColumn style={styles.contTablaRecargos3}>{valorUrgenciaInhabilHost}</TableRowColumn>
                    </TableRow>
                  </TableBody>
                </Table>
              </div>
              {
                tipoPrestacionSelected == 6 || tipoPrestacionSelected == 15 || tipoPrestacionSelected == 26 || tipoPrestacionSelected == 11 ?
                  <div className="col-6">
                    <Table
                      key="tablaConsultaRecargosTecnicas"
                      fixedHeader
                      fixedFooter
                      selectable={false}
                    >
                      <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                        <TableRow selectable={false}>
                          <TableHeaderColumn style={styles.tituloTablaRecargos1}>Tipo de Tecnica</TableHeaderColumn>
                          <TableHeaderColumn style={styles.tituloTablaRecargos2}>Ambulatorio</TableHeaderColumn>
                          <TableHeaderColumn style={styles.tituloTablaRecargos3}>Hospitalario</TableHeaderColumn>
                        </TableRow>
                      </TableHeader>
                      <TableBody
                        displayRowCheckbox={false}
                        deselectOnClickaway={false}
                        showRowHover
                        stripedRows={false}
                      >

                        {
                          (valorTecnicasAmb['Tradicional'] != 'No tiene recargo' || valorTecnicasHost['Tradicional'] != 'No tiene recargo') ?
                            <TableRow key="tradicional">
                              <TableRowColumn style={styles.tituloTablaRecargos1}>Tradicional</TableRowColumn>
                              <TableRowColumn style={styles.contTablaRecargos2}>{valorTecnicasAmb['Tradicional']}</TableRowColumn>
                              <TableRowColumn style={styles.contTablaRecargos3}>{valorTecnicasHost['Tradicional']}</TableRowColumn>
                            </TableRow>
                            :
                            null
                        }


                        {
                          (valorTecnicasAmb['Radiocirugia'] != 'No tiene recargo' || valorTecnicasHost['Radiocirugia'] != 'No tiene recargo') ?
                            <TableRow key="radiocirugia">
                              <TableRowColumn style={styles.tituloTablaRecargos1}>Radiocirugia</TableRowColumn>
                              <TableRowColumn style={styles.contTablaRecargos2}>{valorTecnicasAmb['Radiocirugia']}</TableRowColumn>
                              <TableRowColumn style={styles.contTablaRecargos3}>{valorTecnicasHost['Radiocirugia']}</TableRowColumn>
                            </TableRow>
                            :
                            null
                        }


                        {
                          (valorTecnicasAmb['Endoscopia'] != 'No tiene recargo' || valorTecnicasHost['Endoscopia'] != 'No tiene recargo') ?
                            <TableRow key="endoscopia">
                              <TableRowColumn style={styles.tituloTablaRecargos1}>Endoscopia</TableRowColumn>
                              <TableRowColumn style={styles.contTablaRecargos2}>{valorTecnicasAmb['Endoscopia']}</TableRowColumn>
                              <TableRowColumn style={styles.contTablaRecargos3}>{valorTecnicasHost['Endoscopia']}</TableRowColumn>
                            </TableRow>
                            :
                            null
                        }


                        {
                          (valorTecnicasAmb['Esterotaxica'] != 'No tiene recargo' || valorTecnicasHost['Esterotaxica'] != 'No tiene recargo') ?
                            <TableRow key="esterotaxica">
                              <TableRowColumn style={styles.tituloTablaRecargos1}>Esterotaxica</TableRowColumn>
                              <TableRowColumn style={styles.contTablaRecargos2}>{valorTecnicasAmb['Esterotaxica']}</TableRowColumn>
                              <TableRowColumn style={styles.contTablaRecargos3}>{valorTecnicasHost['Esterotaxica']}</TableRowColumn>
                            </TableRow>
                            :
                            null
                        }


                        {
                          (valorTecnicasAmb['Termoterapia'] != 'No tiene recargo' || valorTecnicasHost['Termoterapia'] != 'No tiene recargo') ?
                            <TableRow key="termoterapia">
                              <TableRowColumn style={styles.tituloTablaRecargos1}>Termoterapia</TableRowColumn>
                              <TableRowColumn style={styles.contTablaRecargos2}>{valorTecnicasAmb['Termoterapia']}</TableRowColumn>
                              <TableRowColumn style={styles.contTablaRecargos3}>{valorTecnicasHost['Termoterapia']}</TableRowColumn>
                            </TableRow>
                            :
                            null
                        }


                        {
                          (valorTecnicasAmb['Microscopica'] != 'No tiene recargo' || valorTecnicasHost['Microscopica'] != 'No tiene recargo') ?
                            <TableRow key="microscopica">
                              <TableRowColumn style={styles.tituloTablaRecargos1}>Microscopica</TableRowColumn>
                              <TableRowColumn style={styles.contTablaRecargos2}>{valorTecnicasAmb['Microscopica']}</TableRowColumn>
                              <TableRowColumn style={styles.contTablaRecargos3}>{valorTecnicasHost['Microscopica']}</TableRowColumn>
                            </TableRow>
                            :
                            null
                        }


                        {
                          (valorTecnicasAmb['Lasik'] != 'No tiene recargo' || valorTecnicasHost['Lasik'] != 'No tiene recargo') ?
                            <TableRow key="lasik">
                              <TableRowColumn style={styles.tituloTablaRecargos1}>Lasik</TableRowColumn>
                              <TableRowColumn style={styles.contTablaRecargos2}>{valorTecnicasAmb['Lasik']}</TableRowColumn>
                              <TableRowColumn style={styles.contTablaRecargos3}>{valorTecnicasHost['Lasik']}</TableRowColumn>
                            </TableRow>
                            :
                            null
                        }


                        {
                          (valorTecnicasAmb['Rayo Laser'] != 'No tiene recargo' || valorTecnicasHost['Rayo Laser'] != 'No tiene recargo') ?
                            <TableRow key="rayoLaser">
                              <TableRowColumn style={styles.tituloTablaRecargos1}>Rayo Laser</TableRowColumn>
                              <TableRowColumn style={styles.contTablaRecargos2}>{valorTecnicasAmb['Rayo Laser']}</TableRowColumn>
                              <TableRowColumn style={styles.contTablaRecargos3}>{valorTecnicasHost['Rayo Laser']}</TableRowColumn>
                            </TableRow>
                            :
                            null
                        }


                        {
                          (valorTecnicasAmb['Video Laparoscopica'] != 'No tiene recargo' || valorTecnicasHost['Video Laparoscopica'] != 'No tiene recargo') ?
                            <TableRow key="videoLaparoscopica">
                              <TableRowColumn style={styles.tituloTablaRecargos1}>Video Laparoscopica</TableRowColumn>
                              <TableRowColumn style={styles.contTablaRecargos2}>{valorTecnicasAmb['Video Laparoscopica']}</TableRowColumn>
                              <TableRowColumn style={styles.contTablaRecargos3}>{valorTecnicasHost['Video Laparoscopica']}</TableRowColumn>
                            </TableRow>
                            :
                            null
                        }


                        {
                          (valorTecnicasAmb['Endovascular'] != 'No tiene recargo' || valorTecnicasHost['Endovascular'] != 'No tiene recargo') ?
                            <TableRow key="endovascular">
                              <TableRowColumn style={styles.tituloTablaRecargos1}>Endovascular</TableRowColumn>
                              <TableRowColumn style={styles.contTablaRecargos2}>{valorTecnicasAmb['Endovascular']}</TableRowColumn>
                              <TableRowColumn style={styles.contTablaRecargos3}>{valorTecnicasHost['Endovascular']}</TableRowColumn>
                            </TableRow>
                            :
                            null
                        }

                      </TableBody>
                    </Table>
                  </div>
                  :
                  null
              }
            </div>

            {this.props.recargosConvenidos.filter((r) => r.CantExcepciones > 0).length > 0 ?
              <div className="row">
                <div className="col-12">
                  <Divider style={{ marginTop: 20 }} />
                  <div style={styles.h2}>
                    *Este grupo puede contener prestaciones con un recargo distinto.
                    Si desea ver prestaciones con excepciones a los recargos generales
                    convenidos, puede realizar una búsqueda avanzada presionando
                    <RaisedButton
                      label="aquí"
                      onClick={this.OpenFiltroBusquedaDetalle}
                      secondary
                      labelStyle={{ fontSize: "10px", paddingLeft: 3, paddingRight: 5 }}
                      overlayStyle={{ borderRadius: 5 }}
                      rippleStyle={{ borderRadius: 5 }}
                      style={{
                        height: 20, width: 45, borderRadius: 5, minWidth: 45, marginLeft: 15,
                      }}
                      buttonStyle={{ borderRadius: 5 }}
                    />
                  </div>
                </div>
              </div>
              : null}
          </CardText>
        </Card>
      </div>
    );
  }
}

ConsultaRecargos.propTypes = {
  recargosConvenidos: PropTypes.array.isRequired,
  tipoPrestacionSelected: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  recargosConvenidos: state.filtroBusquedaRC.recargosConvenidos,
  tipoPrestacionSelected: state.filtroBusquedaRC.tipoPrestacionSelected,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});


export default connect(mapStateToProps, mapDispatchToProps)(ConsultaRecargos);

